import AutoReplenishEmptyHub from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishEmptyHub/AutoReplenishEmptyHub';

export default AutoReplenishEmptyHub;
